import React, { useState } from "react";
import BreadCrumb from "../../Components/BreadCrumb";
import InnerBanner from "../../Components/InnerBanner";
import Spinner from "../../Components/Spinner";
import Viewer from "react-viewer";
import { useGetPhotoGalleryQuery } from "../../../../redux/services/internal/apiHome";

const PhotoGallery = ({ benchId }) => {
  const {
    data: galleryData,
    isLoading,
    isError,
  } = useGetPhotoGalleryQuery(benchId);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  if (isLoading) {
    return <Spinner />;
  }

  if (isError) {
    return <div>Error fetching gallery data!</div>;
  }

  const openViewer = (index) => {
    setPhotoIndex(index);
    setIsViewerOpen(true);
  };

  const images = galleryData.data.map((item) => ({
    src: item.file_path,
    alt: item.title,
  }));

  console.log(" images object ", JSON.stringify(images));

  return (
    <>
      <div className="col-12 col-sm-12 col-md-9 col-lg-9">
        {/* <InnerBanner title="Gallery Photos" /> */}

        <BreadCrumb title="Photo Gallery" />

        <div className="gallery-sec">
          {galleryData.data &&
            galleryData.data.map((item, index) => (
              <a
                className="masonry-item"
                key={index}
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  openViewer(index);
                }}
              >
                <img
                  src={item.file_path}
                  className="img-responsive"
                  alt={item.title}
                />
                <div className="img-details">
                  <h3>{item.title}</h3>
                </div>
              </a>
            ))}
        </div>
      </div>

      {/* React Viewer component */}
      <Viewer
        visible={isViewerOpen}
        onClose={() => setIsViewerOpen(false)}
        images={images}
        activeIndex={photoIndex}
        onChange={(newIndex) => {
          if (newIndex >= 0 && newIndex < images.length) {
            setPhotoIndex(newIndex);
          }
        }}
        zIndex={1000}
      />
    </>
  );
};

export default PhotoGallery;
